import React from 'react';
import xtend from 'xtend';
import { Panel } from 'react-bootstrap';
import { Line, Doughnut, defaults } from 'react-chartjs-2';
import Loader from '../../common/components/notifications/Loader'

defaults.global.responsive = true;
defaults.global.maintainAspectRatio = false;
defaults.global.animation = false;

const chartOptions = {
    fill: false,
    lineTension: 0.4,
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0.0,
    borderJoinStyle: 'miter',
    pointBackgroundColor: '#fff',
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBorderWidth: 2,
    pointRadius: 3,
    pointHitRadius: 10
};

function createDataset (data) {
    return data.map(function (stat) {
        return {
            archiveStreams: stat.activeVod,
            liveStreams: stat.activeLive,
            live247Streams: stat.active247,
            time: stat.time
        }
    })
}

function _getTotal (data, key) {
    try {
        return data[0][key]
    } catch (err) {
        return 0
    }
}

function getLiveTotal (data) {
    var tot = _getTotal(data, 'activeLive') + _getTotal(data, 'activeVod') +
        _getTotal(data, 'active247')
    return String(tot).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
function getLiveMaxInt (data) {
    var totAr = [_getTotal(data, 'activeLive') , _getTotal(data, 'activeVod') ,
        _getTotal(data, 'active247')]
    var maxVal = Math.max(...totAr)
    return maxVal
}
function getLiveMinInt (data) {
    var totAr = [_getTotal(data, 'activeLive') , _getTotal(data, 'activeVod') ,
        _getTotal(data, 'active247')]
    var minVal = Math.min(...totAr)
    return minVal
}

class ViewerChart extends React.PureComponent {
    constructor (props) {
        super(props)
    }

    render () {
        var { props } = this

        var liveData = createDataset(props.viewerCounts).reverse()

        var liveTotal = getLiveTotal(props.viewerCounts)
        //adds 20% to total to increase line chart est. max height
        var topActiveViewersInt =  getLiveMaxInt(props.viewerCounts)
        var tmpMax = Math.round(topActiveViewersInt + ((topActiveViewersInt/100)*20))
        //if the max is <=1 then add 1 more points to the graph so the percent is not lost
        var totPointMax = (tmpMax <= 1)? (tmpMax + 1): tmpMax
        //subtracts 20% to total to set line chart est. min points height unless <=0
        var minActiveViewersInt =  getLiveMinInt(props.viewerCounts)
        var tmpMin = Math.round(minActiveViewersInt - ((topActiveViewersInt/100)*20))
        var totPointMin = (tmpMin <= 0)?0:tmpMin;

        var historicalTotal = (_getTotal(props.viewerCounts, 'vod') +
            _getTotal(props.viewerCounts, 'live') +
            _getTotal(props.viewerCounts, 'live247'))

        var historicalTotalFormatted =
            ('' + (_getTotal(props.viewerCounts, 'vod') +
            _getTotal(props.viewerCounts, 'live') +
            _getTotal(props.viewerCounts, 'live247')))
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")

        const colorRed = 'rgba(242, 81, 81, 0.7)';
        const colorBlue = 'rgba(0, 136, 238, 0.7)';
        const colorOrange = 'rgba(245, 171, 53, 0.7)';

        const liveChartData = {
            labels: liveData.map(function (datum) {
                return datum.time;
            }),
            datasets: [
                xtend(chartOptions, {
                    label: '24/7 Streams',
                    backgroundColor: 'rgba(245, 171, 53, 0.3)',
                    borderColor:colorOrange,
                    pointBorderColor: colorOrange,
                    pointBackgroundColor: '#fff',
                    pointHoverBackgroundColor: colorOrange,
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    data: liveData.map(function (datum) {
                        return datum.live247Streams;
                    })
                }),

                xtend(chartOptions, {
                    label: 'Live Streams',
                    backgroundColor: 'rgba(242, 81, 81, 0.3)',
                    borderColor: colorRed,
                    pointBorderColor: colorRed,
                    pointBackgroundColor: '#fff',
                    pointHoverBackgroundColor: colorRed,
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    data: liveData.map(function (datum) {
                        return datum.liveStreams;
                    })
                }),

                xtend(chartOptions, {
                    label: 'Archive Streams',
                    backgroundColor: 'rgba(0, 136, 238, 0.3)',
                    borderColor: colorBlue,
                    pointBorderColor: colorBlue,
                    pointBackgroundColor: '#fff',
                    pointHoverBackgroundColor: colorBlue,
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    data: liveData.map(function (datum) {
                        return datum.archiveStreams;
                    })
                }),

            ]
        };

        const historicalChartData = {
            labels: [
                'Archive Streams',
                'Live Streams',
                '24/7 Streams'
            ],
            datasets: [{
                data: [
                    _getTotal(props.viewerCounts, 'vod'),
                    _getTotal(props.viewerCounts, 'live'),
                    _getTotal(props.viewerCounts, 'live247')
                ],
                backgroundColor: [
                    colorBlue, colorRed, colorOrange
                ],
                hoverBackgroundColor: [
                    colorBlue, colorRed, colorOrange
                ]
            }]
        };

        var archSum = 0, liveSum = 0, live247Sum = 0;

        liveData.forEach(function (dataset) {
            archSum += dataset.archiveStreams;
            liveSum += dataset.liveStreams;
            live247Sum += dataset.live247Streams;
        });

        var archMean = liveData.length / archSum,
            liveMean = liveData.length / liveSum,
            live247mean = liveData.length / live247Sum;

        var meanViewerCount = Math.ceil(2 / (archMean + liveMean + live247mean));
        var increment =
            (meanViewerCount < 50) ? 10 :
            ((meanViewerCount < 1000) ? 50 : 100);

        let hasNoData = (props.viewerCounts.length <= 0)

        return ( <div id="viewer-wrapper">
            {hasNoData ?
                <Loader /> :
                <Panel>
                    <Panel.Heading>
                        <Panel.Title>
                            <h4>Viewers</h4>
                        </Panel.Title>
                    </Panel.Heading>

                    <Panel.Body>
                        <div className="col-md-8 wrapper-col">
                            <div className="row">
                                <label>Now Viewing</label>
                                <span className="pull-right">
                                    <strong>{liveTotal}</strong> total
                                </span>
                            </div>

                            <Line
                                height={300}
                                data={liveChartData}
                                options={createLineChartOpts({ increment }, { totPointMax }, { totPointMin })}
                            />
                        </div>

                        <div className="col-md-4 wrapper-col">
                            <div className="row">
                                <label>Past 30 Days</label>
                                <span className="pull-right">
                                    <strong>{historicalTotalFormatted}</strong> total
                                </span>
                            </div>

                            {historicalTotal > 0 ?
                                (<Doughnut
                                    data={historicalChartData}
                                    options={{
                                        plugins: {
                                            datalabels: {
                                                display: true,
                                                borderColor: 'white',
                                                backgroundColor: 'rgba(236, 236, 236, 0.5)',
                                                borderRadius: 5,
                                                borderWidth: 1,
                                                color: 'black',
                                                font: {
                                                    weight: 'bold'
                                                },
                                                formatter: function(value) {
                                                    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                                }
                                            }
                                        },
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        // crashes if animation
                                        animation: false,
                                        // animation: {
                                        //     animateRotate: true,
                                        // },

                                        /* legend: {
                                            display: true
                                        } */

                                    }}
                                />) :
                                <div className="alert alert-info">
                                    <strong>No Data</strong>
                                </div>
                            }
                        </div>
                    </Panel.Body>
                </Panel>
            }
            </div>
        );
    }
}

export default ViewerChart;

function createLineChartOpts (increment , max, min) {
    return {
        plugins: {
            datalabels: {
                display: true,
                borderColor: function(context) {
                    return context.dataset.backgroundColor
                },
                borderWidth: 1,
                backgroundColor: function(context) {
                    const parts = context.dataset.backgroundColor.match(/[\d.]+/g);
                    if (parts.length === 3) {parts.push(1)}
                    parts[3] = 0.2
                    return `rgba(${ parts.join(',') })`
				},
				borderRadius: 5,
				color: 'black',
				font: {
				    weight: 'normal'
				},
				formatter: function(value) {
                    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
                align: 'top',
				anchor: 'end'
            }
        },
        maintainAspectRatio: false,
        animation: false,
        responsive: true,
        tooltips: {
            mode: 'label',
           /*  callbacks: {
                label: function(tooltipItem, data) {
                    return tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }, }, */
         },

        elements: {},
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                        stepSize: increment,
                        suggestedMin: min.totPointMin,
                        suggestedMax: max.totPointMax,
                        callback: function (value, index, values) {
                            return String(value)
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    },
                    showLabelBackdrop: true,
                    type: 'linear',
                    display: true,
                    position: 'left',
                    id: 'y-axis-1',
                    labels: {
                        show: true
                    }
                }
            ]
        }

    }
}